import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Segment } from "semantic-ui-react";
import ContentLoader from "~/components/element/ContentLoader";
import FlyerStore from "../applications/panel/stores/FlyerStore";
import FlyerTemplate from "../applications/panel/components/Flyer/FlyerTemplate";
import FlyerBucket from "../applications/panel/components/Flyer/FlyerBucket";
import FlyerForm from "../applications/panel/components/Flyer/FlyerForm";
import { attachAutoScrollHandler, detachAutoScrollHandler } from "~/utils/DnDAutoScroll";
import CustomDndProvider from "~/components/CustomDndProvider";
import "../applications/panel/styles/Flyer.less";

@observer
class FlyerWidget extends Component {
  @observable flyerStore = null;

  constructor(props) {
    super(props);
    this.flyerStore = new FlyerStore();
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount() {
    attachAutoScrollHandler();

    const { tourId } = this.props;

    if (window.frameElement) {
      this.loadInIFrame(tourId, window.frameElement);
    } else {
      this.loadInFullPage(tourId);
    }
  }

  componentWillUnmount() {
    detachAutoScrollHandler();
  }

  onDragEnd(sourceItem, targetItem) {
    this.flyerStore.onDragEnd(sourceItem, targetItem);
  }

  /**
   * This method is only need while we embed the Flyer in the old client panels. Remove once
   * Everybody is on the CPv3
   */
  loadInIFrame(tourId, iframe) {
    this.flyerStore.load(tourId).then(() => {
      // Give a chance for all images to be downloaded and displayed (they have no size while not loaded making
      // the effective page height lower than it will be after everything loads).
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight}px`;
      }, 2000);
    });
  }

  loadInFullPage(tourId) {
    // do not fire immediately since there are already too many xhr elsewhere and the tour edit page feels
    // slow on load, unless we are in an iframe.
    setTimeout(() => this.flyerStore.load(tourId), 3000);
  }

  render() {
    const { previewUrl } = this.props;
    const { isLoading, photoSlots, mediaItems, formStore, listingInformation, characterLimit } = this.flyerStore;
    const { model, setProperty, isDirty } = formStore;

    if (isLoading || photoSlots.length === 0) {
      return <ContentLoader />;
    }

    if (mediaItems.length === 0) {
      return (
        <Segment style={{ textAlign: "center", minHeight: "200px", width: "100%" }}>
          <h2>No media has been uploaded</h2>
        </Segment>
      );
    }

    return (
      <div id="flyer">
        <CustomDndProvider>
          <Segment className="flyer-template-segment">
            <FlyerTemplate photoSlots={photoSlots} onDragEnd={this.onDragEnd} />
          </Segment>
          <Segment>
            <FlyerBucket mediaItems={mediaItems} onDragEnd={this.onDragEnd} />
          </Segment>
          <div className="flyer-description-container">
            <FlyerForm
              description={model.description || ""}
              isDirty={isDirty}
              onDescriptionChange={value => setProperty("description", value)}
              onSave={() => this.flyerStore.save()}
              listingInformation={listingInformation}
              characterLimit={characterLimit}
            />
            &nbsp;&nbsp;
            {previewUrl ? (
              // rel "noopener noreferer" will prevent the browser from sending the referer, and we need it so
              // we can log it.
              // eslint-disable-next-line react/jsx-no-target-blank
              <a href={previewUrl} target="_blank">
                preview last saved flyer
              </a>
            ) : null}
          </div>
        </CustomDndProvider>
      </div>
    );
  }
}

FlyerWidget.propTypes = {
  tourId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  previewUrl: PropTypes.string,
};

export default FlyerWidget;
